import {Menu, Pagination, PaginationItem} from "semantic-ui-react";
import React from 'react'

import createPaginationItems from "semantic-ui-react/src/lib/createPaginationItems/createPaginationItems.js"

const ELLIPSIS_CHARACTER = "…";

export default class DawidPagination extends Pagination {
    constructor(props) {
        super(props);
    }

    handleItemClick = (e, {value: nextActivePage}) => {
        const {activePage: prevActivePage} = this.state;

        // Heads up! We need the cast to the "number" type there, as `activePage` can be a string
        if (+prevActivePage === +nextActivePage) return;

        this.setState({activePage: nextActivePage});
        _.invoke(this.props, 'onPageChange', e, {...this.props, activePage: nextActivePage})
    };

    handleItemOverrides = (active, type, value) => (predefinedProps) => ({
        active,
        type,
        key: `${type}-${value}`,
        onClick: (e, itemProps) => {
            _.invoke(predefinedProps, 'onClick', e, itemProps);
            if (itemProps.type !== 'ellipsisItem') this.handleItemClick(e, itemProps)
        },
    });

    render() {
        const {
            'aria-label': ariaLabel,
            boundaryRange,
            disabled,
            ellipsisItem,
            siblingRange,
            totalPages,
            completed,
            maxLength,
            getIterationName,
            hideIteration
        } = this.props;
        const {activePage} = this.state;

        const items = createPaginationItems({
            activePage,
            boundaryRange,
            hideEllipsis: _.isNil(ellipsisItem),
            siblingRange,
            totalPages,
        });
        // const rest = getUnhandledProps(Pagination, this.props);
        return (
            // <Menu {...rest} aria-label={ariaLabel} pagination role='navigation'>
            <Menu data-currentpage={activePage} data-totalpages={totalPages}
                  aria-label={ariaLabel}
                  pagination role='navigation'>
                {_.map(items, ({active, type, value}) => {
                        // console.log(value);
                        const isComplete = completed[value - 1];
                        const key = type + '-' + value;
                        if (type === 'pageItem') {
                            const shouldBeHidden = hideIteration && hideIteration(value - 1);
                            if (shouldBeHidden) {
                                return;
                            }
                            let content;
                            if (getIterationName) {
                                content = getIterationName(value);
                            } else {
                                content = value;
                            }
                            if (maxLength && content.length > maxLength) {
                                content = content.substring(0, maxLength) + ELLIPSIS_CHARACTER
                            }
                            return (<PaginationItem
                                disabled={disabled} className={isComplete ? 'completed' : 'incomplete'} type={type}
                                value={value} active={active} content={content}
                                key={key} onClick={(e, itemProps) => {
                                this.handleItemClick(e, itemProps)
                            }}/>)
                        }
                        if (type === 'ellipsisItem') {
                            return (<PaginationItem
                                disabled={true} className={isComplete ? 'completed' : 'incomplete'} type={type}
                                value={value} active={active} content={ELLIPSIS_CHARACTER}
                                key={key} onClick={(e, itemProps) => null}/>)
                        }


                        // PaginationItem.create(this.props[type], {
                        //     defaultProps: {
                        //         content: value,
                        //         disabled,
                        //         value,
                        //     },
                        //     overrideProps: this.handleItemOverrides(active, type, value),
                        // })
                    },
                )}
            </Menu>
        )
    }

}
